import { TFieldValidationResult } from "./CtaFieldValidations.types";
import { TAcquisitionProviderFacade } from "../../../facades/AcquisitionProviderFacade/useAcquisitionProviderFacade";
import { isDateValid, isSamePersonCheckFromFacade } from "../../../utils/acquisition-utils";
import { isFieldInvalid } from "./CtaFieldValidations.utils";

export const creditProtectionFieldValidations = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    let validationResult: TFieldValidationResult = {}
    if (
        validatingState.getCreditProtectionInfo().CreditProtectionSelected 
        && (
            !validatingState.getIsCreditProtectionValid()
            || validatingState.getCreditProtectionInfo().CreditProtectionInitials.length < 2
        )
    ){
        validationResult['CreditProtectionInitials'] = 'RequiredField';
    }
    return validationResult;
};

export const authorizedUserFieldValidations = (validatingState: TAcquisitionProviderFacade): TFieldValidationResult => {
    let validationResult: TFieldValidationResult = {}

    if (validatingState.getAuthorizedUser().authorizedUserInfo.IsAuthorizedUserSelected === false) {
        return {};
    }

    const {
        authorizedUserFirstName,
        authorizedUserLastName,
        authorizedUserDateOfBirthDay,
        authorizedUserDateOfBirthMonth,
        authorizedUserDateOfBirthYear,
        authorizedUserSpouse,
    } = validatingState.getPersonalInformation();

    if (isFieldInvalid(authorizedUserFirstName)) {
        validationResult['AuthorizedUserFirstName'] = 'RequiredField';
    }

    if (isFieldInvalid(authorizedUserLastName)) {
        validationResult['AuthorizedUserLastName'] = 'RequiredField';
    }

    if (isSamePersonCheckFromFacade(validatingState)) {
        validationResult['AuthorizedUserFirstName'] = 'RequiredField';
        validationResult['AuthorizedUserLastName'] = 'RequiredField';
        validationResult['AuthorizedUserDateOfBirth'] = 'RequiredField';
    }

    if (!isDateValid(`${authorizedUserDateOfBirthDay.value}/${authorizedUserDateOfBirthMonth.value}/${authorizedUserDateOfBirthYear.value}`, 'au')) {
        validationResult['AuthorizedUserDateOfBirth'] = 'RequiredField';
    }

    if (authorizedUserSpouse.value === undefined) {
        validationResult['IsAuthorizedUserSpouse'] = 'RequiredField';
    }

    return validationResult;
};
